import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { memo, useRef, useEffect } from "react";

const DescriptiveTypingAnswer = memo(
  ({ selectedValue, handleTypingChange, editorInstanceRef, currentSrNo }) => {
    const editorRef = useRef(null);

    // Prevents onChange from firing when setData() is called programmatically
    const isProgrammaticRef = useRef(false);

    // True after the first effect run; skips loading stale selectedValue on initial mount
    const isMountedRef = useRef(false);

    // Sync editor when selectedValue updates from server (skips first mount to avoid stale prop)
    useEffect(() => {
      if (!isMountedRef.current) {
        isMountedRef.current = true;
        return;
      }
      if (!editorRef.current) return;
      const editableEl = editorRef.current.ui?.view?.editable?.element;
      const isFocused = editableEl && editableEl.contains(document.activeElement);
      if (isFocused) return;
      const currentData = editorRef.current.getData();
      const cached = sessionStorage.getItem(`descriptive_answer_${currentSrNo}`);

      const finalData = (selectedValue !== undefined && selectedValue !== null && selectedValue !== 0)
        ? selectedValue
        : cached || "";

      if (currentData !== finalData) {
        isProgrammaticRef.current = true;
        editorRef.current.setData(finalData);
      }
    }, [selectedValue, currentSrNo]);

    return (
      <div style={{ minHeight: "140px" }}>
        <CKEditor
          editor={ClassicEditor}
          config={{
            toolbar: [
              "heading",
              "|",
              "bold",
              "italic",
              "|",
              "bulletedList",
              "numberedList",
              "|",
              "insertTable",
              "|",
              "undo",
              "redo",
            ],
            table: {
              contentToolbar: [
                "tableColumn",
                "tableRow",
                "mergeTableCells",
              ],
            },
          }}
          onReady={(editor) => {
            editorRef.current = editor;
            editorInstanceRef.current = editor;

            // Use only session cache on mount — selectedValue may be from previous question.
            // The sync useEffect will load the confirmed server answer once it arrives.
            const cached = sessionStorage.getItem(`descriptive_answer_${currentSrNo}`);
            isProgrammaticRef.current = true;
            editor.setData(cached || "");
          }}
          onChange={(_event, editor) => {
            if (isProgrammaticRef.current) {
              isProgrammaticRef.current = false;
              return;
            }
            handleTypingChange(editor.getData());
          }}
        />
      </div>
    );
  }
);

export default DescriptiveTypingAnswer;
